import { lazy, useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { Route, Routes } from "react-router-dom";

import { useMediaQuery } from "../hooks/useMediaQuery";
import i18n from "../i18n";
import { useScreenSizeStore } from "../stores/screenSizeStore";

const Dashboard = lazy(() => import("../features/Triage/Dashboard"));

/*
 * This is the main component for the Units module.
 * It initializes the i18n provider and renders the Units component.
 * We have to render this way for i18n.
 */
const Triage = () => {
  // Fullbay Default Breakpoints
  const isMobile = useMediaQuery("(max-width: 767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1199px)");
  const isDesktop = useMediaQuery("(min-width: 1200px)");
  const { setScreenSize, clearInfo } = useScreenSizeStore();

  useEffect(() => {
    clearInfo();

    // Set screensize breakpoints for the UI rendering.
    if (isMobile) {
      setScreenSize("mobile");
    } else if (isTablet) {
      setScreenSize("tablet");
    } else {
      setScreenSize("desktop");
    }
  }, [clearInfo, isDesktop, isMobile, isTablet, setScreenSize]);

  return (
    <I18nextProvider i18n={i18n}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
      </Routes>
    </I18nextProvider>
  );
};

export default Triage;
